import { AppStrings } from "../../../utils/constants/AppStrings";
import { formatCurrency } from "../../../utils/financialFormatters";

export const SGP_LIMITS_BY_SPORT_PANEL_KEY = "by-sport";
export const SGP_LIMITS_BY_LEAGUE_PANEL_KEY = "by-league";

const SGP_LIMITS_PANEL_DEFINITIONS = [
  {
    key: SGP_LIMITS_BY_SPORT_PANEL_KEY,
    title: AppStrings.LIMITS_BY_SPORT_TITLE,
    entityTitle: AppStrings.SPORT,
    entityField: "sport",
  },
  {
    key: SGP_LIMITS_BY_LEAGUE_PANEL_KEY,
    title: AppStrings.LIMITS_BY_LEAGUE_TITLE,
    entityTitle: AppStrings.LEAGUE_LABEL,
    entityField: "league",
  },
];

export const getSgpLimitsPanels = (currencySymbol) =>
  SGP_LIMITS_PANEL_DEFINITIONS.map(
    ({ key, title, entityTitle, entityField }) => ({
      key,
      title,
      showEditButton: true,
      editableField: "defaultLimit",
      editableValueType: "currency",
      columns: [
        {
          title: entityTitle,
          dataIndex: entityField,
          key: entityField,
          width: "50%",
        },
        {
          title: AppStrings.DEFAULT_SGP_COMBO_LIMIT_LABEL,
          dataIndex: "defaultLimit",
          key: "defaultLimit",
          width: "50%",
          sorter: (firstRow, secondRow) =>
            firstRow.defaultLimit - secondRow.defaultLimit,
          render: (value) => formatCurrency(value, currencySymbol, 0),
        },
      ],
      rows: [],
    }),
  );

export const SGP_LIMITS_TABS = SGP_LIMITS_PANEL_DEFINITIONS.map(
  ({ key, title }) => ({
    label: title,
    value: key,
  }),
);

export const SGP_LIMITS_TEST_IDS = {
  sportPanel: "sgp-limits-sport-panel",
  leaguePanel: "sgp-limits-league-panel",
};
